import { 
  GET_ADMIN_DASHBOARD_STICKY_COLUMNS, 
  GET_ADMIN_DASHBOARD_STICKY_COLUMNS_ERROR, 
  GET_ADMIN_DASHBOARD_STICKY_COLUMNS_SUCCESS,
  UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS,
  UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS_ERROR,
  UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS_SUCCESS,
} from "./actionTypes"

const initialState = {
  error: null,
  admin_dashboard_column_preference: null,
  loading: false
}

const adminDashboardColumnPreference = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_DASHBOARD_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case GET_ADMIN_DASHBOARD_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        admin_dashboard_column_preference: action.payload,
        loading: false
      }

    case GET_ADMIN_DASHBOARD_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        admin_dashboard_column_preference: action.payload,
        loading: false
      }

    case UPDATE_ADMIN_DASHBOARD_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}

export default adminDashboardColumnPreference;
